import { defineComponent, ref, watch, watchPostEffect } from 'vue'

import { MsClose } from '@sunrise/icons'
import { pageUtils } from '@sunrise/shared'

import { AriaLabel } from './MsLightbox.enum'

export default defineComponent({
    name: 'MsLightbox',
    components: { MsClose },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const wrapperRef = ref<HTMLElement | null>(null)
        let prevActiveEl: HTMLElement | null

        watch(
            () => props.visible,
            (visible) => (visible ? pageUtils.disablePageScroll() : pageUtils.enablePageScroll()),
        )

        watchPostEffect(() => (props.visible ? setFocus() : resetFocus()))

        function setFocus() {
            if (wrapperRef.value) {
                prevActiveEl = document.activeElement as HTMLElement
                wrapperRef.value.focus()
            }
        }

        function resetFocus() {
            prevActiveEl?.focus()
            prevActiveEl = null
        }

        function close() {
            emit('update:visible', false)
        }

        return {
            wrapperRef,
            close,
            AriaLabel,
        }
    },
})
